<template>
    <div>
        <div class="col-md-12">
            <div class="card border-0 rounded shadow">
                <div class="card-body">
                    <h5 class="card-title">Reagendar consulta</h5>
                    <hr>
                    <Times v-if="schedule != null"
                           :id_prof="schedule.id_prof"
                           :id_place="schedule.id_place"
                           :id_spec="schedule.id_spec"
                           :id_city="schedule.sched_online ? null : schedule.id_city"
                           :id_insurance="schedule.id_insurance"
                           :id_paymeth="schedule.id_paymeth"
                           :id_sched_father="schedule.id_sched"
                           :professional="professional"
                           @onClickDate="reSchedule"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Times from "../components/Times";
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Swal from "sweetalert2";
import Device from "../../helpers/device";

export default {
    name: "ReSchedule",
    components: {
        Times,
    },
    data() {
        return {
            state: 'loading',
            token: null,
            scheduleId: null,
            userId: null,
            schedule: null,
            professional: null,
            startEndDays: this.isMobile() ? 3 : 7,
        }
    },
    created() {
        let params = atob(this.$route.query.params)
        let [token, userId, scheduleId] = params.split('@');
        this.token = token;
        this.userId = userId;
        this.scheduleId = scheduleId;
        this.authUsingToken();
        this.findSchedule();
    },
    methods: {
      isMobile() {
        return Device.isMobile();
      },
        authUsingToken() {
            this.$store.dispatch('auth/loginUsingToken', this.token)
                .finally(() => {
                    this.state = 'loaded';
                });
        },
      loadProfessional() {
        let params = {
          id_place: this.schedule.id_place,
          id_city: this.schedule.sched_online ? null : this.schedule.id_city,
          id_spec: this.schedule.id_spec,
          id_paymeth: this.schedule.id_paymeth,
          id_insurance: this.schedule.id_insurance,
          with_availability: true,
          start_end_days: this.startEndDays,
          id_prof: this.schedule.id_prof,
          id_sched_father: this.schedule.id_sched_father,
        };

        if (!this.schedule.id_prof)
          return;

        http.get(`/schedule/professionals/${this.schedule.id_prof}`, {params: params}).then((response) => {
          this.professional = response.data;
        });
      },
        findSchedule() {
            return http.get(`/users/${this.userId}/schedules/${this.scheduleId}`)
                .then((response) => {
                    this.schedule = response.data;

                    this.loadProfessional();

                    return response;
                });
        },
        reSchedule(availabilityTime) {
            let param = {
                sched_date: availabilityTime.available_date,
                sched_time: availabilityTime.available_time,
                sched_datetime_patient: availabilityTime.sched_datetime_patient,
            };
            if (availabilityTime.id_avail != null && availabilityTime.id_avail !== '') {
                param.id_avail = availabilityTime.id_avail;
            }
            if (availabilityTime.id_place_location) {
                param.id_place_location = availabilityTime.id_place_location;
            }

            http.post(`/users/${this.userId}/schedules/${this.scheduleId}/reschedule`, param)
                .then(() => {
                    Swal.fire({
                        title: 'Aeeeh!',
                        text: 'Reagendamento realizado com sucesso.',
                        icon: 'success',
                        allowOutsideClick: false,
                        confirmButtonText: 'Acessar minha conta',
                        confirmButtonColor: '#780f5a',
                    }).then(() => {
                        this.$router.push('/schedules')
                    });
                })
                .catch((e) => Alert.error(e.response.data));
        }
    }
}
</script>

<style scoped>

</style>